import { ActivatedRoute, Router } from '@angular/router';
import { ViewMoreComponent } from './view-more/view-more.component';
import { DataAnalyticsService } from './../../services/data-analytics.service';
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import * as c3 from 'c3';
import { MatDialog } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import { Usagereport } from 'src/app/shared/handlers/usagereport';
import { takeUntil } from 'rxjs/operators';

let subscr: any = null;

const COLORS = [
  '#515CB4', '#D26999', '#72A8D5', '#82C7C2', '#7FE593',
  '#8F82C7', '#BF82C7', '#D27969', '#FDBF6F', '#FD8A6F'
];
@Component({
  selector: 'app-da-cost-contributions',
  templateUrl: './da-cost-contributions.component.html',
  styleUrls: ['./da-cost-contributions.component.scss']
})
export class DaCostContributionsComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('graphDiv') graphDiv: ElementRef;
  chart: any;
  @Input() factorySummary: any;

  selectedCostContribution: string;
  costContributionItems: Array<any> = [];
  constContributionFilteredList: Array<any> = [];
  graphData: Array<any> = [];
  graphFilteredData: Array<any> = [];
  graphColorObj = {};
  graphTitle = '';
  graphHoverTitle = '';
  graphHoverCost = '';
  graphHoverPercentage = '';
  message: string;
  isLoading = false;
  level: string;
  lineId: string;
  lineName: string;
  costContributionSubscriptions: Subscription;
  startTime: Date;

  constructor(
    private daService: DataAnalyticsService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private usageReport: Usagereport
  ) { }

  ngOnInit() {
    subscr = this.route.queryParams.subscribe(params => {
      if (params.level && params.factory) {
        // check if not empty
        this.lineName = params.LineName;
        if (this.costContributionSubscriptions) {
          this.costContributionSubscriptions.unsubscribe();
        }
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.route.queryParams.subscribe(params => {
        if (params.level && params.factory) {
          this.level = params.level;
          if (this.level === 'factory') {
            this.selectedCostContribution = 'Line';
          } else if (this.level === 'line') {
            this.selectedCostContribution = 'Sku';
          }
          this.lineId = (params.LineId) ? params.LineId : null;
          this.drawGraph(this.lineId);
        }
      });
    }, 0);
  }

  openDialog(): void {
    this.dialog.open(ViewMoreComponent, {
      width: '840px',
      data: {
        costContributionItems: this.costContributionItems,
        graphData: this.graphData,
        graphColorObj: this.graphColorObj,
        factorySummary: this.factorySummary,
        selectedCostContribution: this.selectedCostContribution,
        startTime: this.startTime
      },
      autoFocus: false
    });
  }

  drawGraph(lineId = null) {
    this.message = 'Loading...';
    this.isLoading = true;
    const params: any = {
      FromDate: this.factorySummary.fromDate,
      ToDate: this.factorySummary.toDate,
      FactoryId: this.factorySummary.factoryId,
      Level: this.level,
      SplitBy: this.selectedCostContribution,
      PageNumber: 1,
      PageSize: 10
    };

    if (this.level === 'line') {
      params.LineId = lineId;
    }
    this.costContributionItems = [];
    this.constContributionFilteredList = [];
    this.graphData = [];
    this.graphFilteredData = [];
    this.graphColorObj = {};
    this.generateDonutChart();
    this.costContributionSubscriptions = this.daService.getCostContributionList(params)
      .subscribe((res => {
        this.startTime = new Date();
        if (res) {
          this.costContributionItems = res.map((item, index) => {
            return {
              id: (this.selectedCostContribution === 'Line') ? item.id : (item.name) ? item.name : 'Null',
              name: (this.selectedCostContribution === 'Line' && item.name && item.name !== 'Not Available') ?
                (item.name) ? item.name : 'Null' : item.id,
              color: (index <= COLORS.length) ? COLORS[index] : this.getRandomColor(),
              percentage: Number(Math.round((item.waste / Math.abs(item.totalWaste)) * 100)),
              cost: item.waste
            };
          });

          this.costContributionItems.forEach(element => {
            if (isNaN(element.percentage)) {
              element.percentage = 0;
            }
          });
          this.costContributionItems.sort((a, b) => {
            return a.percentage === b.percentage ? 0 : a.percentage < b.percentage ? 1 : -1;
          });

          this.constContributionFilteredList = this.costContributionItems.slice(0, 10);

          this.graphFilteredData = this.constContributionFilteredList.reduce((acc, item) => {
            acc.push([item.name, item.percentage]);
            return acc;
          }, []);
          let duplicateCount = 1;
          this.graphColorObj = this.constContributionFilteredList.reduce((acc, item) => {
            if (acc[item.name]) {
              acc[item.name + duplicateCount] = item.color;
              duplicateCount++;
            }
            acc[item.name] = item.color;
            return acc;
          }, {});

          this.graphData = this.costContributionItems.reduce((acc, item) => {
            acc.push([item.name, item.percentage]);
            return acc;
          }, []);
          this.isLoading = false;
          this.generateDonutChart();
        } else {
          this.costContributionItems = [];
          this.constContributionFilteredList = [];
          this.graphData = [];
          this.graphFilteredData = [];
          this.graphColorObj = {};
          this.generateDonutChart();
          this.message = 'Data not available.';
        }
      }));
  }

  generateDonutChart() {
    this.chart = c3.generate({
      bindto: this.graphDiv.nativeElement,
      size: {
        height: 200,
        width: 200
      },
      data: {
        columns: this.graphFilteredData,
        type: 'donut',
        colors: this.graphColorObj
      },
      donut: {
        title: this.graphTitle,
        width: 20,
        label: {
          show: false
        },
        expand: true,
      },
      legend: {
        hide: true
      },
      tooltip: {
        format: {
          value(value, ratio, id) {
            return `${value}%`;
          }
        }
      }
    });
  }

  onClickCostContribution(item: any) {

    let level = '';
    let cluster = null;
    let factory = null;
    let line = null;
    const sku = null;

    if (this.selectedCostContribution === 'Line') {
      level = 'Factory';
      cluster = this.factorySummary.clusterId;
      factory = this.factorySummary.factoryName;
    }
    if (this.selectedCostContribution === 'Sku') {
      level = 'Line';
      cluster = this.factorySummary.clusterId;
      factory = this.factorySummary.factoryName;
      line = this.lineName;
    }

    this.usageReport.report('Insight Dashboard - ' + level, this.startTime, cluster, factory, line, sku);

    this.graphHoverTitle = '';
    this.graphHoverCost = '';
    this.graphHoverPercentage = '';
    if (this.selectedCostContribution === 'Line') {
      const queryParamsData: any = {
        cluster: this.factorySummary.clusterId,
        factory: this.factorySummary.factoryId,
        FromDate: this.factorySummary.fromDate,
        ToDate: this.factorySummary.toDate,
      };
      if (this.level === 'factory') {
        queryParamsData.level = 'line';
        queryParamsData.LineId = item.id;
        queryParamsData.LineName = item.name && item.name.toLowerCase() === 'not available' ? item.id : item.name;
      }
      this.router.navigate([],
        {
          relativeTo: this.route,
          queryParams: queryParamsData,
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        }
      );
    } else if (this.level !== 'factory' && this.selectedCostContribution === 'Sku') {

      this.router.navigate(
        ['/sku-insights'],
        {
          queryParams: {
            cluster: this.factorySummary.clusterId,
            factory: this.factorySummary.factoryId,
            skuId: item.id,
            skuName: item.name,
            lineId: this.lineId,
            lineName: this.lineName,
            FromDate: this.factorySummary.fromDate,
            ToDate: this.factorySummary.toDate,
            level: 'sku'
          }
        }
      );
    }
  }

  onChange(event) {
    this.selectedCostContribution = event.value;
    this.drawGraph(this.lineId);
  }

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  onChangeDate(start, end) {
    this.factorySummary.fromDate = start;
    this.factorySummary.toDate = end;
    this.drawGraph();
  }

  setGraphTitle(item = null) {
    if (item) {
      this.graphHoverTitle = item.name;
      this.graphHoverCost = item.cost;
      this.graphHoverPercentage = `${item.percentage}%`;
    } else {
      this.graphHoverTitle = '';
      this.graphHoverCost = '';
      this.graphHoverPercentage = '';
    }
    // this.generateDonutChart();
  }

  ngOnDestroy(): void {
    if (subscr) {
      subscr.unsubscribe();
    }
    if (this.costContributionSubscriptions) {
      this.costContributionSubscriptions.unsubscribe();
    }
  }
}
